import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const addAccessKeyCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("ADD_ACCESS_KEY_COMMAND"),
    ownerId: providerIdZodSchema,
    accessTo: z.array(
        z.union([orderIdZodSchema, orderGroupIdZodSchema, resourceIdZodSchema]),
    ),
    expiresAt: isoAndUnixZodSchema.optional(),
    reuseExistingKey: z.boolean(),
});
type AddAccessKeyCommand = z.infer<typeof addAccessKeyCommandZodSchema>;

const addAccessKeyCommandFactory = (
    params: Except<AddAccessKeyCommand, "_id" | "_type">,
): AddAccessKeyCommand => {
    return {
        _id: generateId({ prefix: "add_access_key_command__" }),
        _type: "ADD_ACCESS_KEY_COMMAND",
        ...params,
    };
};

export { addAccessKeyCommandFactory, addAccessKeyCommandZodSchema };
export type { AddAccessKeyCommand };
